import { SWRConfiguration } from "swr"
import characteristics from "../constants/breed-characteristics/breed-characteristics-content.json"
import heroImages from "../constants/pet-breed/breeds-images.json"
import cost from "../constants/breed-characteristics/breed-costs.json"
import moreOnBreed from "../constants/breed-characteristics/more-on-breed.json"
import { urlifyComplexName } from "../constants/stateCityDictionary"

export const CACHE_KEYS = {
  BREED_DATA: (breed: string) => `breed-${breed}`,
  RSS_FEED: (url: string) => `rss-${url}`,
  COSTS: (breed: string) => `costs-${breed}`,
}

export const REVALIDATE_TIMES = {
  BREED_PAGE: 86400, // 24 hours
  RSS_FEED: 3600, // 1 hour
}

export const SWR_CONFIG: SWRConfiguration = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
}

export async function fetchBreedData(params: {
  breed: string
  animal: "dog" | "cat"
}) {
  const [breedData, heroImageData, costs, moreOnBreedsData] = await Promise.all(
    [
      // Find breed data
      Promise.resolve(
        characteristics.find(
          (breed) =>
            urlifyComplexName(breed.breed) === params.breed &&
            breed.animal === params.animal,
        ),
      ),
      // Find hero image
      Promise.resolve(
        heroImages.find(
          (item) => urlifyComplexName(item.breed) === params.breed,
        ) || null,
      ),
      // Find costs
      Promise.resolve(
        cost.find((item) => urlifyComplexName(item.breed) === params.breed) ||
          null,
      ),
      // Find more on breed data
      Promise.resolve(
        moreOnBreed.find(
          (item) => urlifyComplexName(item.breed) === params.breed,
        ) || null,
      ),
    ],
  )

  return { breedData, heroImageData, costs, moreOnBreedsData }
}
